import React, { Fragment } from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Image from "pages/_components/Image";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import * as i18nUtils from "util/i18n";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { actions as environmentActions } from "reducers/environment";
import { Col, Row } from "react-bootstrap";
import Notification from "pages/_components/Notification";
import EnvironmentStepper from "../_components/EnvironmentStepper";

const StepFinishPayway = ({ isMobile }) => {
    const dispatch = useDispatch();

    return (
        <Fragment>
            <HeaderSimple className="d-flex justify-content-between" inverse showNotifications />
            <Notification scopeToShow="environment" />
            <MainContainer className="onboarding">
                <EnvironmentStepper isMobile={isMobile} page="StepFinishPayway" />

                <div className="step-container">
                    <div className={isMobile ? "py-3" : "py-6"} />
                    <h2 className="text-center">
                        {i18nUtils.get("payway.lastStep.title", "Solicitud enviada de forma exitosa")}
                    </h2>

                    <div className="illustration-alta-persona flex justify-center mb-8">
                        <Image src="images/figma/illustrations/paywayLastStep.svg" className="svg-image" />
                    </div>
                    <div className="box box-border-soft payway-last-step-text-container">
                        <p>
                            {i18nUtils.get(
                                "payway.lastStep.text",
                                // eslint-disable-next-line max-len
                                "Tu solicitud fue enviada correctamente. Los datos y la documentación serán analizados, y en breve, uno de nuestros ejecutivos se pondrá en contacto con vos.",
                            )}
                        </p>
                    </div>

                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                bsStyle="primary"
                                label="global.finalize"
                                loading={false}
                                block
                                onClick={() => dispatch(environmentActions.lastStepPayway())}
                            />
                        </Col>
                    </Row>
                </div>
            </MainContainer>
        </Fragment>
    );
};

StepFinishPayway.propTypes = {
    isMobile: bool.isRequired,
};

export default connect()(StepFinishPayway);
